export type WorkType = 'tv' | 'movie';

export interface Work {
  id: string;
  title: string;
  type: WorkType;
  cover: string;
  backdrop: string;
  year: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  synopsis: string;
  updateTime: string;
  hot: number;
  episodes: number;
}

export const tvGenres = ['都市', '悬疑', '历史', '爱情', '科幻', '犯罪', '家庭', '古装'];
export const movieGenres = ['科幻', '剧情', '动作', '爱情', '悬疑', '冒险', '喜剧', '犯罪'];
export const regions = ['大陆', '日韩', '欧美', '中国香港'];
export const years = ['2026', '2025', '2024', '2023', '2022'];

export const works: Work[] = [
  /* ---------------- 电视剧 ---------------- */
  {
    id: 'tv-001',
    title: '都市晨光',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20urban%20drama%20poster%2C%20young%20professional%20looking%20out%20of%20a%20glass%20office%20tower%20at%20golden%20sunrise%2C%20moody%20teal%20and%20warm%20orange%20lighting%2C%20shallow%20depth%20of%20field%2C%20premium%20editorial%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv001-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20modern%20city%20skyline%20at%20dawn%20with%20warm%20golden%20light%20cutting%20through%20deep%20blue%20clouds%2C%20moody%20atmospheric%20film%20still%2C%20shallow%20depth%20of%20field%2C%20teal%20and%20orange%20color%20grading%2C%20high%20detail%20cinematic%20composition&width=1600&height=900&seq=tv001-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['都市', '家庭'],
    director: '林致远',
    actors: ['周牧云', '许静好', '陈一鸣'],
    rating: 8.6,
    synopsis:
      '在大城市打拼多年的女主林晓棠，在一场突如其来的行业风暴中失去工作，被迫回到老城区与家人同住。面对代际矛盾与自我怀疑，她重新拾起初心，与一群同样不甘平凡的朋友一起创业，在都市的晨曦中寻找属于自己的光。剧情以细腻的生活质感和真实的情感冲突，勾勒出一代年轻人的奋斗与成长。',
    updateTime: '2026-10-11',
    hot: 9820,
    episodes: 36,
  },
  {
    id: 'tv-002',
    title: '长夜将明',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20drama%20poster%2C%20detective%20silhouette%20under%20a%20single%20street%20lamp%20in%20heavy%20rain%2C%20deep%20navy%20and%20amber%20lighting%2C%20moody%20noir%20atmosphere%2C%20premium%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv002-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20rainy%20night%20city%20alley%20with%20glowing%20amber%20street%20lamps%20and%20deep%20blue%20shadows%2C%20moody%20noir%20film%20still%2C%20reflective%20wet%20pavement%2C%20suspense%20atmosphere%2C%20high%20detail%20cinematic%20composition&width=1600&height=900&seq=tv002-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['悬疑', '犯罪'],
    director: '高铭川',
    actors: ['赵砚清', '孟繁星', '李泽言'],
    rating: 9.1,
    synopsis:
      '一桩跨越十年的悬案在小城重启调查，刑警队长韩野发现所有线索都指向一个沉默的夜晚。随着真相浮出水面，受害者与加害者的界限逐渐模糊，正义的代价变得沉重。剧集以冷峻的影像和层层反转的叙事，探讨人性深处的光与暗，被观众称为年度最强悬疑之作。',
    updateTime: '2026-10-10',
    hot: 11240,
    episodes: 24,
  },
  {
    id: 'tv-003',
    title: '山河旧梦',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20poster%2C%20elegant%20woman%20in%20traditional%20silk%20costume%20standing%20in%20an%20ancient%20palace%20corridor%2C%20warm%20amber%20torchlight%20and%20deep%20blue%20shadows%2C%20premium%20epic%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv003-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20courtyard%20at%20dusk%20with%20amber%20lanterns%20and%20deep%20blue%20twilight%20sky%2C%20mist%20over%20mountains%2C%20cinematic%20historical%20film%20still%2C%20painterly%20atmosphere%2C%20high%20detail%20composition&width=1600&height=900&seq=tv003-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['历史', '古装'],
    director: '沈书白',
    actors: ['苏清月', '顾长风', '温以宁'],
    rating: 8.8,
    synopsis:
      '承平之世，朝堂暗流涌动。出身书香门第的女官沈砚，凭借过人的才识卷入一场关乎天下安危的博弈。她在权谋与理想之间艰难抉择，与少年将军并肩守护山河。剧集以宏大的历史格局与精致的美术呈现，谱写一曲关于家国与信念的旧梦长歌。',
    updateTime: '2026-10-09',
    hot: 8760,
    episodes: 40,
  },
  {
    id: 'tv-004',
    title: '归途列车',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%2C%20warm%20candid%20portrait%20of%20a%20young%20woman%20by%20a%20train%20window%20at%20sunset%2C%20soft%20amber%20glow%20and%20cool%20blue%20shadows%2C%20emotional%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv004-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20view%20from%20a%20train%20window%20crossing%20golden%20rice%20fields%20at%20sunset%2C%20warm%20amber%20light%20and%20soft%20blue%20hills%2C%20nostalgic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv004-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['家庭', '都市'],
    director: '陆知远',
    actors: ['何佳期', '邵星辰', '郑婉柔'],
    rating: 8.3,
    synopsis:
      '常年在外打拼的青年程放，因为母亲的一通电话踏上返乡的列车。十几个小时的车程里，他遇见了形形色色的旅人，也逐渐想起被自己遗忘的故乡与亲情。剧集用一段温暖的旅途，讲述关于回家、和解与成长的故事，平淡中见真情。',
    updateTime: '2026-10-08',
    hot: 7210,
    episodes: 30,
  },
  {
    id: 'tv-005',
    title: '迷雾追踪',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%2C%20female%20investigator%20holding%20a%20flashlight%20in%20thick%20fog%2C%20deep%20navy%20and%20amber%20accents%2C%20tense%20moody%20atmosphere%2C%20premium%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv005-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Eerie%20foggy%20forest%20road%20at%20night%20with%20a%20single%20set%20of%20car%20headlights%2C%20deep%20blue%20haze%20and%20amber%20glow%2C%20cinematic%20mystery%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv005-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['悬疑', '犯罪'],
    director: '高铭川',
    actors: ['孟繁星', '裴亦寒', '赵砚清'],
    rating: 8.9,
    synopsis:
      '连续多起失踪案的现场都留下一枚相同的旧钥匙，女刑警苏蔓循线追查，却发现案件与多年前的一起意外有着千丝万缕的联系。浓雾笼罩的小城之下，每个人都在隐瞒什么。一步步逼近真相的过程，也是她直面内心创伤的旅程。',
    updateTime: '2026-10-07',
    hot: 9530,
    episodes: 28,
  },
  {
    id: 'tv-006',
    title: '春日纪事',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20drama%20poster%2C%20young%20couple%20standing%20under%20blooming%20cherry%20blossoms%2C%20soft%20warm%20light%20with%20gentle%20blue%20shadows%2C%20romantic%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv006-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dreamy%20spring%20park%20path%20lined%20with%20pink%20cherry%20blossoms%2C%20warm%20sunlight%20and%20soft%20blue%20sky%2C%20romantic%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv006-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['爱情', '都市'],
    director: '许南词',
    actors: ['郑婉柔', '顾长风', '何佳期'],
    rating: 8.0,
    synopsis:
      '花店女孩与图书编辑因一本旧书结缘，在春天的小城里开始了一段慢热的爱情。两人各自背负着过往的遗憾，在一次次误解与靠近中学会坦诚。剧集用清新的画面和细腻的对白，记录一段温柔而克制的春日心动。',
    updateTime: '2026-10-06',
    hot: 6540,
    episodes: 24,
  },
  {
    id: 'tv-007',
    title: '长安烟云',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20historical%20epic%20poster%2C%20knight%20in%20dark%20armor%20on%20a%20city%20wall%20at%20dusk%2C%20warm%20amber%20torchlight%20and%20deep%20blue%20sky%2C%20grand%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv007-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20walls%20glowing%20with%20amber%20lanterns%20under%20a%20deep%20blue%20dusk%20sky%2C%20cinematic%20epic%20historical%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv007-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['历史', '古装'],
    director: '沈书白',
    actors: ['顾长风', '苏清月', '裴亦寒'],
    rating: 8.5,
    synopsis:
      '盛世长安的繁华之下，一场围绕皇权与民生的暗战正在展开。寒门出身的少年将军，凭借一身胆识在风云变幻的朝局中步步为营。剧集以厚重的大唐气象与紧凑的叙事节奏，展现一段荡气回肠的权谋传奇。',
    updateTime: '2026-10-05',
    hot: 8120,
    episodes: 45,
  },
  {
    id: 'tv-008',
    title: '心跳信号',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20poster%2C%20young%20female%20doctor%20in%20warm%20hospital%20corridor%20looking%20hopeful%2C%20soft%20amber%20and%20cool%20blue%20lighting%2C%20modern%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv008-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Serene%20hospital%20corridor%20at%20golden%20hour%20with%20warm%20light%20streaming%20through%20large%20windows%2C%20soft%20blue%20shadow%2C%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv008-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['爱情', '都市'],
    director: '许南词',
    actors: ['何佳期', '李泽言', '郑婉柔'],
    rating: 8.2,
    synopsis:
      '急诊科医生与心外科天才在医院里朝夕相处，从针锋相对的同事变成彼此信赖的伙伴。面对生死的考验，他们逐渐读懂了对方藏在专业冷静之下的温柔。剧集以真实动人的医疗场景，讲述关于责任与心动的故事。',
    updateTime: '2026-10-04',
    hot: 7380,
    episodes: 32,
  },
  {
    id: 'tv-009',
    title: '深空回响',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20poster%2C%20astronaut%20looking%20at%20a%20distant%20glowing%20planet%2C%20deep%20blue%20space%20with%20warm%20amber%20nebula%2C%20epic%20sci-fi%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv009-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Deep%20space%20starfield%20with%20a%20giant%20glowing%20amber%20planet%20and%20deep%20blue%20nebula%20clouds%2C%20epic%20cinematic%20sci-fi%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv009-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['科幻', '悬疑'],
    director: '林致远',
    actors: ['裴亦寒', '许静好', '赵砚清'],
    rating: 8.7,
    synopsis:
      '一支深空探测队在执行任务时接收到一段来历不明的信号，信号的频率竟与地球上某个早已消失的信号源完全一致。随着调查深入，队员们发现这趟旅程远比想象中危险。剧集以硬核的想象力与克制的叙事，叩问人类在宇宙中的位置。',
    updateTime: '2026-10-03',
    hot: 8940,
    episodes: 20,
  },
  {
    id: 'tv-010',
    title: '沉默的证词',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20legal%20crime%20poster%2C%20female%20lawyer%20in%20a%20dim%20courtroom%20holding%20documents%2C%20deep%20navy%20and%20amber%20lighting%2C%20serious%20moody%20atmosphere%2C%20high%20detail&width=600&height=900&seq=tv010-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Empty%20grand%20courtroom%20at%20dusk%20with%20warm%20amber%20light%20through%20tall%20windows%20and%20deep%20blue%20shadows%2C%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv010-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['犯罪', '悬疑'],
    director: '陆知远',
    actors: ['孟繁星', '苏清月', '李泽言'],
    rating: 8.4,
    synopsis:
      '年轻律师接手一桩看似证据确凿的旧案，却在翻阅卷宗时发现关键证词存在矛盾。为了替当事人讨回公道，她顶住压力层层追查，揭开被时间掩埋的真相。剧集聚焦司法与人性的交锋，节奏紧凑、发人深省。',
    updateTime: '2026-10-02',
    hot: 7620,
    episodes: 30,
  },
  {
    id: 'tv-011',
    title: '风起南洋',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20period%20poster%2C%20young%20merchant%20standing%20on%20a%20wooden%20ship%20deck%20at%20sunset%2C%20warm%20amber%20sky%20and%20deep%20blue%20sea%2C%20epic%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv011-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Traditional%20sailing%20ship%20crossing%20a%20shimmering%20sea%20at%20golden%20sunset%2C%20warm%20amber%20sky%20and%20deep%20blue%20water%2C%20cinematic%20adventure%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv011-back&orientation=landscape',
    year: 2025,
    region: '中国香港',
    genres: ['古装', '历史'],
    director: '周慕棠',
    actors: ['顾长风', '温以宁', '邵星辰'],
    rating: 8.1,
    synopsis:
      '清末民初，少年商人随商船远赴南洋，在异国的风浪中闯荡出一片天地。商海沉浮、家国情义交织，他逐渐明白财富之外更珍贵的东西。剧集以壮阔的航海画面与跌宕的命运故事，再现一代人的闯荡传奇。',
    updateTime: '2026-10-01',
    hot: 6890,
    episodes: 38,
  },
  {
    id: 'tv-012',
    title: '我们的十年',
    type: 'tv',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20friendship%20drama%20poster%2C%20group%20of%20young%20friends%20laughing%20on%20a%20rooftop%20at%20sunset%2C%20warm%20amber%20light%20and%20soft%20blue%20shadows%2C%20nostalgic%20film%20art%2C%20high%20detail&width=600&height=900&seq=tv012-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rooftop%20view%20of%20a%20city%20at%20golden%20sunset%20with%20warm%20amber%20sky%20and%20deep%20blue%20shadows%2C%20nostalgic%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=tv012-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['都市', '家庭'],
    director: '林致远',
    actors: ['许静好', '邵星辰', '郑婉柔'],
    rating: 8.3,
    synopsis:
      '五位大学同窗在毕业后的十年里各自经历着人生起落，友情在现实的打磨中经受考验。当生活把他们重新聚到一起，那些年少时许下的诺言是否还作数。剧集以温暖的群像笔触，记录一代人的青春与成长。',
    updateTime: '2026-09-30',
    hot: 7010,
    episodes: 36,
  },

  /* ---------------- 电影 ---------------- */
  {
    id: 'mv-001',
    title: '星海拾遗',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20lone%20explorer%20standing%20before%20a%20colossal%20glowing%20space%20station%2C%20deep%20blue%20and%20warm%20amber%20accents%2C%20epic%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv001-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Gigantic%20futuristic%20space%20station%20orbiting%20a%20glowing%20planet%2C%20deep%20blue%20space%20and%20warm%20amber%20engine%20glow%2C%20epic%20cinematic%20sci-fi%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv001-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['科幻', '冒险'],
    director: '林致远',
    actors: ['裴亦寒', '许静好', '顾长风'],
    rating: 8.8,
    synopsis:
      '在人类文明濒临资源枯竭的时代，一支小队踏上寻找失落星图的远征。他们穿越未知星域，面对宇宙深处的危险与自身信念的考验。影片以恢弘的视觉与深邃的思考，讲述一段关于希望与传承的太空史诗。',
    updateTime: '2026-10-11',
    hot: 12480,
    episodes: 0,
  },
  {
    id: 'mv-002',
    title: '无声告白',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20emotional%20drama%20movie%20poster%2C%20middle-aged%20father%20sitting%20alone%20in%20a%20dim%20living%20room%2C%20warm%20amber%20lamp%20and%20deep%20blue%20shadow%2C%20restrained%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv002-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Quiet%20suburban%20street%20at%20dusk%20with%20warm%20amber%20window%20lights%20and%20deep%20blue%20evening%20sky%2C%20melancholic%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv002-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['剧情', '家庭'],
    director: '陆知远',
    actors: ['陈一鸣', '郑婉柔', '温以宁'],
    rating: 8.6,
    synopsis:
      '一个不善言辞的父亲，在女儿出国留学前夕终于鼓起勇气说出埋藏多年的心里话。一场关于理解与和解的家庭对话，让两代人重新看见彼此。影片以克制的镜头与真挚的表演，讲述平凡生活里最难开口的爱。',
    updateTime: '2026-10-10',
    hot: 8320,
    episodes: 0,
  },
  {
    id: 'mv-003',
    title: '夜色狂奔',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%2C%20driver%20in%20a%20neon-lit%20sports%20car%20at%20night%2C%20deep%20blue%20and%20warm%20amber%20streaks%2C%20high%20energy%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv003-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rain-soaked%20night%20highway%20with%20glowing%20amber%20car%20lights%20and%20deep%20blue%20streaks%2C%20high%20energy%20cinematic%20action%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv003-back&orientation=landscape',
    year: 2026,
    region: '中国香港',
    genres: ['动作', '犯罪'],
    director: '周慕棠',
    actors: ['邵星辰', '李泽言', '孟繁星'],
    rating: 8.2,
    synopsis:
      '王牌车手为替兄弟洗清冤屈，被迫卷入一场横跨全城的夜间追逐。在速度与危险的边缘，他必须做出关乎生死的选择。影片以凌厉的剪辑与硬核的实拍场面，带来一场酣畅淋漓的都市动作盛宴。',
    updateTime: '2026-10-09',
    hot: 10890,
    episodes: 0,
  },
  {
    id: 'mv-004',
    title: '山间来信',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%2C%20young%20woman%20reading%20a%20letter%20in%20a%20sunlit%20mountain%20village%2C%20warm%20amber%20light%20and%20soft%20blue%20shadows%2C%20gentle%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv004-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Terraced%20mountain%20village%20at%20golden%20sunset%20with%20warm%20amber%20light%20and%20soft%20blue%20mist%2C%20romantic%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv004-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['爱情', '剧情'],
    director: '许南词',
    actors: ['郑婉柔', '李泽言', '何佳期'],
    rating: 8.1,
    synopsis:
      '城市女孩偶然读到一封寄错地址的旧信，循着信中的线索来到一座山村，遇见写信的人。两人在山水之间慢慢靠近，也在过往的遗憾中学会放下。影片以诗意的画面与温柔的情感，讲述一段跨越时空的相遇。',
    updateTime: '2026-10-08',
    hot: 6450,
    episodes: 0,
  },
  {
    id: 'mv-005',
    title: '幻影列车',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20movie%20poster%2C%20lone%20passenger%20in%20an%20empty%20night%20train%20carriage%2C%20deep%20blue%20and%20warm%20amber%20lighting%2C%20eerie%20atmosphere%2C%20high%20detail&width=600&height=900&seq=mv005-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Empty%20vintage%20train%20carriage%20at%20night%20with%20warm%20amber%20lamps%20and%20deep%20blue%20shadows%2C%20mysterious%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv005-back&orientation=landscape',
    year: 2026,
    region: '日韩',
    genres: ['悬疑', '剧情'],
    director: '金敏叙',
    actors: ['裴亦寒', '苏清月', '赵砚清'],
    rating: 8.5,
    synopsis:
      '一列只在午夜出现的列车，载着七位素不相识的乘客驶向未知的终点。随着旅程推进，他们发现彼此的秘密竟紧密相连。影片以密闭空间与非线性叙事，编织出一个关于记忆与救赎的悬疑谜题。',
    updateTime: '2026-10-07',
    hot: 8760,
    episodes: 0,
  },
  {
    id: 'mv-006',
    title: '老街往事',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20nostalgic%20drama%20movie%20poster%2C%20elderly%20shopkeeper%20standing%20in%20an%20old%20street%20alley%20at%20dusk%2C%20warm%20amber%20light%20and%20deep%20blue%20shadows%2C%20high%20detail%20film%20art&width=600&height=900&seq=mv006-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20Chinese%20street%20alley%20with%20warm%20amber%20lanterns%20and%20deep%20blue%20twilight%2C%20nostalgic%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv006-back&orientation=landscape',
    year: 2024,
    region: '大陆',
    genres: ['剧情'],
    director: '陆知远',
    actors: ['陈一鸣', '温以宁', '邵星辰'],
    rating: 8.7,
    synopsis:
      '一条即将拆迁的老街，一群守着小店过日子的普通人。镜头跟随他们度过最后的四季，记录下市井烟火里的温情与告别。影片以朴实无华的笔触，留住一段正在消失的城市记忆。',
    updateTime: '2026-10-06',
    hot: 5980,
    episodes: 0,
  },
  {
    id: 'mv-007',
    title: '风暴之眼',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20action%20thriller%20poster%2C%20special%20forces%20soldier%20standing%20in%20a%20storm%2C%20deep%20blue%20lightning%20and%20warm%20amber%20fire%20glow%2C%20intense%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv007-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dramatic%20storm%20over%20a%20coastal%20city%20with%20deep%20blue%20clouds%20and%20warm%20amber%20city%20lights%2C%20intense%20cinematic%20action%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv007-back&orientation=landscape',
    year: 2026,
    region: '欧美',
    genres: ['动作', '冒险'],
    director: 'Andreas Cole',
    actors: ['邵星辰', 'Marcus Reed', 'Elena Frost'],
    rating: 8.0,
    synopsis:
      '一场罕见的超强风暴逼近沿海城市，一支救援小队必须在数小时内完成撤离任务。面对失控的局势与艰难的抉择，他们把生的希望留给别人。影片以震撼的灾难场面与紧张节奏，塑造一群逆风而行的凡人英雄。',
    updateTime: '2026-10-05',
    hot: 9340,
    episodes: 0,
  },
  {
    id: 'mv-008',
    title: '时光信箱',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20romance%20movie%20poster%2C%20young%20woman%20holding%20a%20glowing%20old%20letterbox%2C%20warm%20amber%20magic%20glow%20and%20deep%20blue%20shadows%2C%20dreamy%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv008-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dreamy%20sunset%20park%20with%20floating%20glowing%20letters%20and%20warm%20amber%20light%20against%20deep%20blue%20sky%2C%20fantasy%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv008-back&orientation=landscape',
    year: 2025,
    region: '日韩',
    genres: ['爱情', '剧情'],
    director: '金敏叙',
    actors: ['郑婉柔', '金泰旻', '何佳期'],
    rating: 8.3,
    synopsis:
      '一个能寄信给过去的旧信箱，让失去爱人的女孩重新与那段时光相连。她一次次修改信中的内容，却发现问题并不在从前。影片以奇幻的设定包裹温柔的思念，讲述关于告别与释怀的故事。',
    updateTime: '2026-10-04',
    hot: 7120,
    episodes: 0,
  },
  {
    id: 'mv-009',
    title: '荒原猎手',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%2C%20lone%20hunter%20standing%20in%20a%20vast%20desolate%20canyon%20at%20sunset%2C%20warm%20amber%20rock%20and%20deep%20blue%20sky%2C%20epic%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv009-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vast%20desolate%20canyon%20landscape%20at%20golden%20sunset%20with%20warm%20amber%20rocks%20and%20deep%20blue%20sky%2C%20epic%20cinematic%20adventure%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv009-back&orientation=landscape',
    year: 2024,
    region: '欧美',
    genres: ['冒险', '动作'],
    director: 'Andreas Cole',
    actors: ['Marcus Reed', 'Elena Frost', '陈一鸣'],
    rating: 7.9,
    synopsis:
      '在资源匮乏的荒原上，一位孤独的猎手为寻找失踪的同伴踏上远征。他穿越险恶的地形，对抗自然的严酷与人性的贪婪。影片以壮丽的荒野影像与硬朗的叙事风格，讲述一个关于生存与守望的故事。',
    updateTime: '2026-10-03',
    hot: 6340,
    episodes: 0,
  },
  {
    id: 'mv-010',
    title: '最后一课',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20inspiring%20drama%20movie%20poster%2C%20elderly%20teacher%20facing%20a%20small%20classroom%20of%20students%2C%20warm%20amber%20light%20and%20soft%20blue%20shadows%2C%20emotional%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv010-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunlit%20rural%20classroom%20with%20warm%20amber%20light%20through%20windows%20and%20deep%20blue%20shadows%2C%20warm%20cinematic%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv010-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['剧情'],
    director: '沈书白',
    actors: ['陈一鸣', '温以宁', '何佳期'],
    rating: 8.9,
    synopsis:
      '一位乡村教师即将退休，他决定为山里的孩子们上好最后一堂课。课堂上，他讲述的不仅是知识，更是关于勇气与远方的人生道理。影片以质朴的情感与细腻的细节，致敬每一位默默耕耘的教育者。',
    updateTime: '2026-10-02',
    hot: 7860,
    episodes: 0,
  },
  {
    id: 'mv-011',
    title: '深海迷航',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20underwater%20sci-fi%20poster%2C%20diver%20in%20a%20glowing%20submersible%20in%20the%20deep%20ocean%2C%20deep%20blue%20water%20and%20warm%20amber%20lights%2C%20epic%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv011-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Deep%20ocean%20trench%20with%20glowing%20amber%20bioluminescence%20in%20deep%20blue%20water%2C%20mysterious%20cinematic%20sci-fi%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv011-back&orientation=landscape',
    year: 2026,
    region: '大陆',
    genres: ['科幻', '冒险'],
    director: '林致远',
    actors: ['裴亦寒', '苏清月', 'Marcus Reed'],
    rating: 8.4,
    synopsis:
      '一支海洋科考队潜入地球上最深的沟壑，试图解开一段神秘信号的来源。随着下潜深度增加，他们发现的远不止未知生物。影片以沉浸式的深海影像与紧张的悬念，带来一场惊心动魄的探险之旅。',
    updateTime: '2026-10-01',
    hot: 9020,
    episodes: 0,
  },
  {
    id: 'mv-012',
    title: '喜剧人生',
    type: 'movie',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20feel-good%20comedy%20movie%20poster%2C%20cheerful%20comedian%20under%20a%20warm%20spotlight%20on%20stage%2C%20warm%20amber%20and%20deep%20blue%20backdrop%2C%20playful%20film%20art%2C%20high%20detail&width=600&height=900&seq=mv012-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Warm%20vintage%20theatre%20stage%20with%20amber%20spotlight%20and%20deep%20blue%20curtains%2C%20playful%20cinematic%20comedy%20film%20still%2C%20high%20detail%20composition&width=1600&height=900&seq=mv012-back&orientation=landscape',
    year: 2025,
    region: '大陆',
    genres: ['喜剧', '剧情'],
    director: '许南词',
    actors: ['李泽言', '郑婉柔', '邵星辰'],
    rating: 8.2,
    synopsis:
      '一个默默无闻的小人物为了站上梦想的舞台，闹出一连串啼笑皆非的故事。在一次次失败与坚持之间，他逐渐找到属于自己的笑声。影片以轻松幽默的方式，讲述普通人追逐梦想的温暖力量。',
    updateTime: '2026-09-30',
    hot: 6780,
    episodes: 0,
  },
];

export const heroIds = ['mv-001', 'tv-002', 'tv-003', 'mv-010', 'tv-009'];

export const hotPicksIds = ['tv-002', 'mv-001', 'mv-010', 'tv-009', 'tv-005', 'mv-003'];
